import { Dispatch } from 'redux';
import { Services } from '../../types/services';

const FETCH_NOTES_REQUEST = 'FETCH_NOTES_REQUEST';
const GET_TAG_TYPES = 'GET_TAG_TYPES';
const GET_EMPTY_NOTE = 'GET_EMPTY_NOTE';
const NOTES_ERROR = 'NOTES_ERROR';

interface Note {
  id?: string;
  [key: string]: unknown;
}

interface TagGroup {
  [key: string]: unknown;
}

interface State {
  emptyNote: Record<string, unknown>;
  tagTypes: TagGroup[];
  loading: boolean;
  error: string;
}

const initialState: State = {
  emptyNote: {},
  tagTypes: [],
  loading: false,
  error: '',
};

interface Action {
  type: string;
  payload?: unknown;
}

export const reducer = (state = initialState, action: Action): State => {
  switch (action.type) {
    case FETCH_NOTES_REQUEST:
      return { ...state, loading: true };
    case GET_EMPTY_NOTE:
      return { ...state, emptyNote: action.payload as Record<string, unknown> };
    case GET_TAG_TYPES:
      return { ...state, tagTypes: action.payload as TagGroup[] };
    case NOTES_ERROR:
      return { ...state, loading: false, error: action.payload as string };
    default:
      return state;
  }
};

export const actions = (services: Services) => {
  const axiosCall = services.axios.Axios();

  const fetchNotesRequest = () => ({ type: FETCH_NOTES_REQUEST });

  const notesError = (error: string) => ({ type: NOTES_ERROR, payload: error });

  const getEmptyNote = (note: Record<string, unknown>) => ({ type: GET_EMPTY_NOTE, payload: note });

  const getTagTypes = (tags: TagGroup[]) => ({ type: GET_TAG_TYPES, payload: tags });

  const fetchNotes = (practiceID: string, pageNumber = 1) => {
    return async (dispatch: Dispatch) => {
      try {
        dispatch(fetchNotesRequest());
        const response = await axiosCall.get(
          `practices/${practiceID}/notes?pageSize=1000&pageNumber=${pageNumber}`,
        );
        const notes = (response as unknown as { data: { data: { items: Note[] } } }).data.data
          .items;
        return notes;
      } catch (error: unknown) {
        dispatch(notesError((error as Error).message));
      }
    };
  };

  const fetchEmptyNote = () => {
    return async (dispatch: Dispatch) => {
      try {
        dispatch(fetchNotesRequest());
        const response = await axiosCall.get(`notes/empty`);
        const emptyNote = (response as unknown as { data: { data: { tagGroups: TagGroup[] } } })
          .data.data;
        const tagTypes = emptyNote.tagGroups;
        dispatch(getEmptyNote(emptyNote));
        dispatch(getTagTypes(tagTypes));
      } catch (error: unknown) {
        dispatch(notesError((error as Error).message));
      }
    };
  };

  const getTags = () => async () => axiosCall.get('notes/tags');

  const createNote = (payload: Record<string, unknown>) => async () =>
    axiosCall.post('notes', payload);

  const getNotes = (practiceId: string) => async () =>
    axiosCall.get('notes', { params: { practiceId } });

  return {
    createNote,
    fetchEmptyNote,
    fetchNotes,
    getNotes,
    getTags,
  };
};
